<template>
    <b-modal
        id="edit-enps-research"
        size="lg"
        centered
        hide-header
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
    >
        <div v-if="isLoading" class="loader">
            <Loader :loader="isLoading" />
        </div>
        <Form
            v-else
            :research="research"
            @submit="submitHandler"
            @cancel="cancelHandler"
            researchTitle="enps.editEnpsResearch"
            submitButton="form.button.save"
            :isNewResearch="false"
        />
    </b-modal>
</template>
<script>
import Form from '../components/Form'
import Loader from '@/views/components/loader'
import { getResearch } from '@/views/enps/api'
import enpsMixin from './enpsMixin'

export default {
    name: 'EditEnpsResearch',
    components: {
        Form,
        Loader,
    },
    mixins: [enpsMixin],
    props: {
        isEditing: true,
    },
    data() {
        return {
            isLoading: true,
            research: null,
        }
    },
    computed: {
        researchId() {
            return this.$route.params.id
        },
    },
    mounted() {
        this.openModal()
        this.getResearchFromApi()
    },
    methods: {
        openModal() {
            this.$bvModal.show('edit-enps-research')
        },
        getResearchFromApi() {
            this.isLoading = true
            getResearch(this.researchId)
                .then(research => {
                    this.research = research
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        submitHandler(data) {
            this.onSubmit(
                this.researchId,
                data,
                'update',
                'research-updated',
                'edit-enps-research'
            )
        },
        cancelHandler() {
            this.onCancel('edit-enps-research')
        },
    },
}
</script>
<style scoped>
.loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 300px;
}
</style>
